"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const hauling_types_1 = require("./hauling.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    isLoadingExportPdf: false,
    isLoadingExportExcel: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    dataItem: {
        id: '',
        contractor_name: '',
        driver: '',
        hauler_no: '',
        vessel: '',
        vessel_capacity_1: 0,
        vessel_capacity_2: 0,
        vessel_no_1: '',
        vessel_no_2: '',
        modified_by: '',
        modified_date: new Date()
    },
    dataStates: {
        filterable: false,
        sortable: false,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'contractor_name', dir: 'desc' },
            { field: 'hauler_no', dir: 'desc' },
        ]
    }
};
const haulingReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hauling_types_1.haulingTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hauling_types_1.haulingTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hauling_types_1.haulingTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingExportPdf, isLoadingExportExcel } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingExportPdf: isLoadingExportPdf ? isLoadingExportPdf : initialState.isLoadingExportPdf, isLoadingExportExcel: isLoadingExportExcel ? isLoadingExportExcel : initialState.isLoadingExportExcel });
    },
    [hauling_types_1.haulingTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [hauling_types_1.haulingTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingExportPdf: false, isLoadingExportExcel: false });
    },
    [hauling_types_1.haulingTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload }) });
    },
    [hauling_types_1.haulingTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [hauling_types_1.haulingTypes.SET_EXPORT_DOCUMENTS]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingExportPdf: false, isLoadingExportExcel: false, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [hauling_types_1.haulingTypes.CLEAR_EXPORT_DOCUMENTS]: () => {
        return Object.assign(Object.assign({}, initialState), { documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    }
});
exports.default = haulingReducer;
